/*
 * @Author: owen
 * @Date: 2022-04-08 10:30:41
 * @LastEditors: owen
 * @LastEditTime: 2022-05-06 12:03:14
 * @FilePath: \app-pcweb\src\main.js
 */
import "babel-polyfill";
import "@/lobby_common/utils/urlInit.js";
import Vue from "vue";
import "normalize.css/normalize.css";
import {
  Button,
  Dialog,
  Input,
  InputNumber,
  Select,
  Option,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Form,
  FormItem,
  Row,
  Col,
  Container,
  Header,
  Main,
  Aside,
  Carousel,
  CarouselItem,
  Tooltip,
  Popover,
  Drawer,
  Steps,
  Step,
  Skeleton,
  SkeletonItem,
  Pagination,
  Menu,
  MenuItem,
  Submenu,
  Progress,
  Image,
  Divider,
  Switch,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Loading,
  Message,
  MessageBox,
  Notification,
  Avatar,
  InfiniteScroll,
  // Table,
  // TableColumn,
  TabPane,
  Tabs,
} from "element-ui";

import "element-ui/lib/theme-chalk/display.css";
import "@/style/theme_root.css";
//  const variables= {
//   /* --------颜色变量Start--------- */
//   /* 投影-顶部导航投影 */
//   '--background-100':'red',
//   '--border-color-100': 'red',
//    '--background-200': 'red',
//   '--background-300': 'red',
// }
// const root = document.documentElement;
//       for (const [key, value] of Object.entries(variables)) {
//         root.style.setProperty(key, value);
//       }
// document.documentElement.setAttribute("theme", "dark");

import locale from "element-ui/lib/locale";
import "@/style/css/common.css";
import "@/style/element-variables.scss";
import "@/assets/font/font.css";
import "@/style/theme-black/black-theme.scss";

import App from "./App.vue";
import router from "@/lobby_common/router";
import store from "@/lobby_common/store";
import i18n from "@/lobby_common/locale"; // Internationalizati
// import VConsole from "vconsole"; // import vconsole
import { utils, isMobile, px2rem } from "@/lobby_common/utils/utils";
import { eventPost } from "@/lobby_common/utils/eventFunction";
import winPop from "@/lobby_common/utils/pop.js";
import popConfig from "@/lobby_common/utils/popConfig.js";
import PayGame from "@/lobby_common/utils/payGame";
import VueTour from "vue-tour";
import Bus from "@/lobby_common/utils/bus.js";
import Exposure from "@/lobby_common/utils/exposure.js";
// import "./registerServiceWorker";
import globalMixin from "./mixins/index";
import telegramUtil from "@/lobby_common/utils/telegramUtil.js";
import { getLocalStorage } from "@/lobby_common/utils/auth.js";
import Intersect from "@/lobby_common/utils/intersect.js";
// import "./registerServiceWorker";0
// import { authid } from '@/lobby_common/directive/auth'; // 导入 auth 函数
require("@/lobby_common/utils/randomUUID.js");
require("vue-tour/dist/vue-tour.css");

// 按钮权限ui指令
// authid(Vue);
Vue.use(VueTour);
// Element UI 国际化适配
locale.i18n((key, value) => i18n.t(key, value));

// 按需注册组件
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Select);
Vue.use(Option);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Row);
Vue.use(Col);
Vue.use(Container);
Vue.use(Header);
Vue.use(Main);
Vue.use(Aside);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Tooltip);
Vue.use(Popover);
Vue.use(Drawer);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Skeleton);
Vue.use(SkeletonItem);
// Vue.use(Table);
// Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Submenu);
Vue.use(Progress);
Vue.use(Image);
Vue.use(Divider);
Vue.use(Switch);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Loading.directive);
Vue.use(Avatar);
Vue.use(InfiniteScroll);
Vue.use(TabPane);
Vue.use(Tabs);
// Vue.use(Table);
// Vue.use(TableColumn);

// 挂载全局服务
Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;

// Vue.use(Element, { i18n: (key, value) => i18n.t(key, value) });
// 全局mixins
Vue.mixin(globalMixin);

if (process.env.NODE_ENV !== "production") {
  localStorage.setItem("skmode", true);
}
// if (isMobile()) {
//   // console.log(process.env.NODE_ENV, "--------vconsole-----------");
//   // if (["development", "sit", "test"].includes(process.env.NODE_ENV)) {

//     new VConsole(); // 初始化
//   // }
// }

import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload, {
  // error: "",
  // loading: 'https://cdn-papp-pc.fellda.com/file/icon/web11/pc/zh/111000301.jpg?t=1724061117',
  preLoad: 1.2,
  attempt: 1,
});

import disableDevtool from "@/lobby_common/utils/disableDevtool.js";
const queryObj = getLocalStorage("localInitQuery") || {};
const localSkmode = getLocalStorage("skmode");
const skmode = queryObj.skmode || localSkmode;
// console.log("skmode", skmode, process.env.PACKAGE_VERSION);
if (skmode !== "true" && skmode !== true) {
  Vue.use(disableDevtool, {});
}

Vue.prototype.$utils = utils;
Vue.config.productionTip = false;
// Vue.config.devtools = true; // 测试代码，可以在控制台看到vuex数据

// 全局 弹框调用方法
Vue.prototype.$isPopShow = function (opt = { show: true, views: "" }) {
  store.commit("setPopBox", opt);
};
Vue.prototype.$Bus = Bus;
Vue.prototype.$eventPost = eventPost;
Vue.prototype.$PayGame = PayGame;
Vue.prototype.$winPop = winPop;
Vue.prototype.$popConfig = popConfig;
Vue.prototype.$px2rem = px2rem;

// 等待 telegramUtil 初始化
window._isTG && telegramUtil.init();

// 全局指令 触底加载更多
Vue.directive("scroll", {
  bind(el, binding) {
    const SELECTWRAP_DOM = el;
    SELECTWRAP_DOM.addEventListener("scroll", function () {
      const condition = SELECTWRAP_DOM.scrollHeight - SELECTWRAP_DOM.scrollTop <= SELECTWRAP_DOM.clientHeight;
      if (condition) {
        binding.value();
      }
    });
  },
});
// 注册全局指令
Vue.directive("intersect", Intersect);
Exposure.init();
// 全局指令 监听元素曝光
Vue.directive("exposure", {
  bind(el, binding, vnode) {
    Exposure.addEl(el, binding.value);
  },
});

new Vue({
  i18n,
  router,
  store,
  data() {
    return {
      viewsLoading: false,
    };
  },
  render: (h) => h(App),
}).$mount("#app");
